
export const MEALPLANS_GROUP_ROUTES = {
  BASE: "/mealplan/*",
  LIST: "/",
};

export const MEALPLANS_GROUP_LINKS = {
  BASE: "/app/mealplan",
  LIST: "/app/mealplan",
};